/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ResultListDataRepresentationAlfrescoEndpointRepresentation } from '../model';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class IntegrationAlfrescoOnPremiseApi extends BaseApi {
    getAllSites(repositoryId) {
        throwIfNotDefined(repositoryId, 'networkId');
        const pathParams = {
            repositoryId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco/{repositoryId}/sites',
            pathParams
        });
    }
    getContentInFolderPath(repositoryId, siteId, folderPath) {
        throwIfNotDefined(repositoryId, 'networkId');
        throwIfNotDefined(siteId, 'siteId');
        throwIfNotDefined(folderPath, 'folderPath');
        const pathParams = {
            repositoryId,
            siteId,
            folderPath
        };
        return this.get({
            path: '/api/enterprise/rest/integration/alfresco/{repositoryId}/sites/{siteId}/folderpath/{folderPath}/content',
            pathParams
        });
    }
    getContentInFolder(repositoryId, folderId) {
        throwIfNotDefined(repositoryId, 'networkId');
        throwIfNotDefined(folderId, 'folderId');
        const pathParams = {
            repositoryId,
            folderId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco/{repositoryId}/folders/{folderId}/content',
            pathParams
        });
    }
    getContentInSite(repositoryId, siteId) {
        throwIfNotDefined(repositoryId, 'networkId');
        throwIfNotDefined(siteId, 'siteId');
        const pathParams = {
            repositoryId,
            siteId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco/{repositoryId}/sites/{siteId}/content',
            pathParams
        });
    }
    getRepositories(opts) {
        return this.get({
            path: '/api/enterprise/profile/accounts/alfresco',
            queryParams: opts,
            returnType: ResultListDataRepresentationAlfrescoEndpointRepresentation
        });
    }
}
